import React, { Component } from "react";
import { Row, Col } from "reactstrap";

import { Route, Switch } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import ClientsList from "./List";
import ClientForm from "./Form";
import Client from "./View";
import NotFound from "../NotFound";

import { PageHeader } from "../Shared";

import { clientActions } from "./actions/clients.actions";

export class ManageClients extends Component {
  componentDidMount() {
    this.getClients();
  }

  getClients = () => {
    this.props.getClients();
  };

  render() {
    const { fetching, fetched, response, error, match } = this.props;

    return (
      <div className="Clients">
        <Row>
          <Col>
            <PageHeader pageId="clients" pageTitle="Manage Clients" />
          </Col>
        </Row>

        <div className="content-wrapper">
          <Switch>
            <Route
              exact
              path={match.url}
              render={() => (
                <ClientsList
                  match={match}
                  data={response}
                  loadData={this.getClients}
                  fetching={fetching}
                  fetched={fetched}
                  error={error}
                />
              )}
            />
            <Route
              path={`${match.url}/list`}
              render={() => (
                <ClientsList
                  match={match}
                  data={response}
                  loadData={this.getClients}
                  fetching={fetching}
                  fetched={fetched}
                  error={error}
                />
              )}
            />
            <Route path={`${match.url}/add`} component={ClientForm} />
            <Route path={`${match.url}/view/:id`} component={Client} />
            <Route path={`${match.url}/edit/:id`} component={ClientForm} />
            <Route component={NotFound} />
          </Switch>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { fetching, fetched, response, error } = state.clients;
  return {
    fetching,
    fetched,
    response,
    error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getClients: bindActionCreators(
      clientActions.getAllClients,
      dispatch
    )
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageClients);
